"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _ramda = require("ramda");

var _checkboxDropdown = _interopRequireDefault(require("../../components/checkbox-dropdown"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _searchBarFilter = _interopRequireDefault(require("../../components/search-bar-filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /**  array of items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /**  content alignment */
  justifyContent: _propTypes.string,

  /** used to close the dropdown and empty the search */
  onCancelClick: _propTypes.func,

  /** on change event handler */
  onChangeHandler: _propTypes.func,

  /** list click handler */
  onItemClickHandler: _propTypes.func,

  /** search query text */
  searchQuery: _propTypes.string,

  /** selected items array */
  selectedItems: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** If true then show the cancel icon */
  showCancel: _propTypes.bool
};
var BoxContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "search-filter-list__BoxContainer",
  componentId: "sc-10y69sw-0"
})(["&:focus,&:hover{box-shadow:0 3px 5px 1px rgba(0,0,0,0.08);border:none;}"]);
var listContainerStyles = {
  height: 0,
  left: 0,
  maxHeight: "222px",
  minWidth: "100%",
  opacity: 0,
  overflow: "hidden",
  overflowY: "auto",
  position: "relative",
  top: "100%",
  zIndex: 1
};

var SearchFilterList = function SearchFilterList(_ref) {
  var items = _ref.items,
      onChangeHandler = _ref.onChangeHandler,
      onItemClickHandler = _ref.onItemClickHandler,
      searchQuery = _ref.searchQuery,
      selectedItems = _ref.selectedItems,
      justifyContent = _ref.justifyContent,
      showCancel = _ref.showCancel,
      onCancelClick = _ref.onCancelClick;
  var wrapperRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      showDropdown = _useState[0],
      setShowDropdown = _useState[1];

  var _useState2 = (0, _react.useState)(selectedItems.length),
      selectionCount = _useState2[0],
      setSelectionCount = _useState2[1];

  var handleShowDropdown = (0, _react.useCallback)(function () {
    return !showDropdown && setShowDropdown(true);
  }, [showDropdown]);
  /** Close dropdown on click outside */

  function handleClickOutside(event) {
    if (showDropdown && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowDropdown(false);
      onCancelClick();
    }
  }

  (0, _react.useEffect)(function () {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement(BoxContainer, {
    border: showDropdown ? "none" : "1px solid grey",
    borderRadius: 8,
    justifyContent: justifyContent || "left",
    onClick: handleShowDropdown
  }, /*#__PURE__*/_react["default"].createElement(_searchBarFilter["default"], {
    borderColor: "white",
    onCancelClick: onCancelClick,
    onChange: onChangeHandler,
    selectionCount: selectionCount,
    showCancel: showCancel,
    value: searchQuery
  }), /*#__PURE__*/_react["default"].createElement(_animations.TransitionHeight, {
    enterDuration: 0.35,
    exitDuration: 0.35,
    fadeInOut: true,
    show: showDropdown
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, listContainerStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    borderTop: "1px solid #3253DC"
  }, /*#__PURE__*/_react["default"].createElement(_checkboxDropdown["default"], {
    items: items,
    onChangeHandler: onItemClickHandler,
    searchQuery: searchQuery,
    selectedItems: selectedItems,
    selectionCountHandler: function selectionCountHandler(checkedItems) {
      return setSelectionCount(checkedItems);
    },
    show: !(0, _ramda.isEmpty)(searchQuery)
  }))))));
};

SearchFilterList.propTypes = propTypes;
SearchFilterList.displayName = "Modules.SearchFilterList";
var _default = SearchFilterList;
exports["default"] = _default;